import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import hashTagApi from "api/hashTagApi";

export const getHashTags = createAsyncThunk("HashTag", async (params: any = {}) => {
  try {
    const response = await hashTagApi.getHashTags(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getHashTag =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await hashTagApi.getHashTag(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postHashTag = async (data: any = {}) => {
  try{
    const response = await hashTagApi.postHashTag(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putHashTag = async (id: string | number , data: any = {}) => {
  try{
    const response = await hashTagApi.putHashTag(id, data);
    return response;
  }catch (error) {
    return error;
  }
};
